import React, { useMemo, useState } from 'react';

import Column from '@amzn/meridian/column';
import Tab, { TabGroup } from '@amzn/meridian/tab';

import { IRateCardDetailStepProps } from 'src/types/IRateCard';

import { ContractTerms } from '../ContractTerms';
import { CoreRates } from '../CoreRates';
import { FirstPartyRates } from '../FirstPartyRates';
import { FullRates } from '../FullRates';
import { ThirdPartyRates } from '../ThirdPartyRates';

export const RateCardTabs = ({
    rateCardValues,
    setRateCardValues,
    planNameToMetadataObj,
    isEditMode,
    augmentedMetadata,
    dataLoaded = true
}: IRateCardDetailStepProps) => {
    const rateCardTabMap = useMemo(
        () => ({
            coreRates: { tabValue: 'coreRates', TabComponent: CoreRates, isEditMode: false },
            contractTerms: { tabValue: 'contractTerms', TabComponent: ContractTerms, isEditMode: false },
            firstPartyRates: { tabValue: 'firstPartyRates', TabComponent: FirstPartyRates, isEditMode: false },
            thirdPartyRates: { tabValue: 'thirdPartyRates', TabComponent: ThirdPartyRates, isEditMode: false },
            // FullRates caclulates final rates if in edit mode
            fullRateSheet: { tabValue: 'fullRateSheet', TabComponent: FullRates, isEditMode: isEditMode }
        }),
        []
    );

    const [currentTab, setCurrentTab] = useState(rateCardTabMap.coreRates.tabValue);

    return (
        <Column height="100%">
            <TabGroup value={currentTab} onChange={setCurrentTab} fill="line">
                <Tab value={rateCardTabMap.coreRates.tabValue}>Core rates</Tab>
                <Tab value={rateCardTabMap.contractTerms.tabValue}>Contract terms</Tab>
                <Tab value={rateCardTabMap.firstPartyRates.tabValue}>First party discount rates</Tab>
                <Tab value={rateCardTabMap.thirdPartyRates.tabValue}>Third party discount rates</Tab>
                <Tab value={rateCardTabMap.fullRateSheet.tabValue}>Full rate sheet</Tab>
            </TabGroup>
            <Column height="100%">
                {[rateCardTabMap[currentTab as keyof typeof rateCardTabMap]].map((tabObject) => (
                    <tabObject.TabComponent
                        key={0}
                        rateCardValues={rateCardValues}
                        setRateCardValues={setRateCardValues}
                        planNameToMetadataObj={planNameToMetadataObj}
                        isEditMode={tabObject.isEditMode}
                        augmentedMetadata={augmentedMetadata}
                        dataLoaded={dataLoaded}
                    />
                ))}
            </Column>
        </Column>
    );
};
